<template>
  <v-expansion-panels v-model="panels" variant="accordion" multiple class="filters-expansion" flat>
    <v-progress-linear v-if="isResourceLoading" indeterminate height="3" color="szRed" />
    <v-expansion-panel :key="0" class="border-bottom-grey">
      <v-expansion-panel-title
        disable-icon-rotate
        class="f-16 font-weight-medium sz-primary-grey--text"
      >
        {{ $t('label.warehouse') }}
        <template #actions>
          <v-icon color="szGrey" class="ico-45-deg" :size="14"> $dropdown </v-icon>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text v-if="!isResourceLoading">
        <ul class="filters-expansion-list f-14">
          <li class="pointer py-1" @click="setWarehouseFilter(-1)">
            <p :class="{ 'font-weight-medium black--text': getWarehouse === -1 }" class="mb-0">
              {{ $t('label.all') }}
            </p>
          </li>
          <li
            v-for="(item, index) in warehouseFilters"
            :key="index"
            class="pointer mb-2"
            @click="setWarehouseFilter(item.warehouse_id)"
          >
            <p
              :class="{ 'font-weight-medium black--text': getWarehouse === item.warehouse_id }"
              class="mb-0"
            >
              {{ item.warehouse_name }}
            </p>
          </li>
        </ul>
      </v-expansion-panel-text>
    </v-expansion-panel>
    <v-expansion-panel :key="1">
      <v-expansion-panel-title
        disable-icon-rotate
        class="f-16 font-weight-medium sz-primary-grey--text"
      >
        {{ $t('label.familyCategory') }}
        <template #actions>
          <v-icon color="szGrey" class="ico-45-deg" :size="14"> $dropdown </v-icon>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text v-if="!isResourceLoading">
        <ul class="filters-expansion-list filters-expansion-list--bulleted f-14">
          <li class="pointer py-1 filters-expansion-list__all" @click="setCategoryId(-1)">
            <p :class="{ 'font-weight-medium black--text': getCategory === -1 }" class="mb-0">
              {{ $t('label.all') }}
            </p>
          </li>
          <li
            v-for="(item, index) in categoryFilters"
            :key="index"
            class="pointer py-1 filters-expansion-list__bullet"
            @click="setCategoryId(item.support_criterion_id)"
          >
            <p
              :class="{
                'font-weight-medium black--text': getCategory === item.support_criterion_id
              }"
              class="mb-0"
            >
              {{ item.name }}
            </p>
          </li>
        </ul>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'FilterExpansionPanels',
  data() {
    return {
      panels: [0]
    }
  },
  computed: {
    getFilter() {
      return this.$store.getters['families/getFilter']
    },
    getCategory() {
      return this.getFilter.categoryId
    },
    getWarehouse() {
      return this.getFilter.warehouseId
    },
    getResourceFilter() {
      return this.$store.getters['families/getResourceFilter']
    },
    categoryFilters() {
      return (this.getResourceFilter && this.getResourceFilter.helpCriteria) || []
    },
    warehouseFilters() {
      return (this.getResourceFilter && this.getResourceFilter.warehouses) || []
    },
    isResourceLoading() {
      return this.$store.getters['families/getResourceLoader']
    }
  },
  watch: {
    getCategory(val) {
      if (val !== -1) {
        this.$store.commit('families/setFilter', { isDifficult: -1 })
      }
    },
    getWarehouse(val) {
      if (val !== -1) {
        this.$store.commit('families/setFilter', { isDifficult: -1 })
      }
    }
  },
  created() {
    if (this.getCategory !== -1) {
      this.panels.push(1)
    }
  },
  methods: {
    setWarehouseFilter(id) {
      this.$store.commit('families/setFilter', { warehouseId: id, offset: 1 })
      this.$emit('close')
    },
    setCategoryId(id) {
      this.$store.commit('families/setFilter', { categoryId: id, offset: 1 })
      this.$emit('close')
    }
  }
}
</script>
